<template>
  <div style="overflow: hidden">
    <module-icon
      :size="size"
      :iconHeight="iconHeight"
      :invertImgIcons="invertImgIcons"
      :iconWidth="iconWidth"
      :icon-color="iconColor"
      :module="module"
    ></module-icon>
    <div v-if="isUnreadCountFeatureEnabled && unreadCount" class="op-badge" :class="unreadCountBadgeColor" :style="badgeStyle">{{ unreadCount }}</div>
  </div>
</template>

<script>
import ModuleIcon from './ModuleIcon';

export default {
  name: 'ModuleIconWithBadge',
  components: {
    ModuleIcon,
  },

  props: {
    invertImgIcons: { type: Boolean, default: false },
    unreadCount: { type: Number },
    isUnreadCountFeatureEnabled: { type: Boolean, default: true },
    module: Object,
    iconColor: String,
    badgeOutsideBox: { type: Boolean, default: false },
    badgeYOffset: { type: Number, default: 0 },
    unreadCountBadgeColor: String,
    size: {
      type: Number,
      default: 24,
    },
    iconHeight: Number, // if set, the icon height will be set and the size used for height and width is ignored
    iconWidth: Number, // if set, the icon width will be set and the size used for height and width is ignored
  },
  computed: {
    badgeStyle() {
      return {
        background: this.unreadCountBadgeColor,

        transform: this.badgeOutsideBox ? `translate(42px,${-70 + this.badgeYOffset}px)` : `translate(20px,${-55 + this.badgeYOffset}px)`,
      };
    },
  },
};
</script>
